export const getAgentsByOrganization = /* GraphQL */ `
  query AgentsByOrganization(
    $organizationId: ID!
    $filter: ModelAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAgentsByOrganization(
      organizationId: $organizationId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tone
      }
      nextToken
    }
  }
`;

export const getAgentsByUserAndOrganization = /* GraphQL */ `
  query AgentsByUserAndOrganization(
    $userId: ID!
    $organizationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAgentsByUserAndOrganization(
      userId: $userId
      organizationId: { eq: $organizationId }
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        personality
        userId
        createdAt
        updatedAt
        tone
      }
      nextToken
    }
  }
`;
